import React from 'react';
import { putPAAAA010ClickBanner } from '../../services/Api';
import { getImageSrc } from '../../utils';
import ResumeItem from './ResumeItem';
import Loader from './Loader';

const ResumeList = ({ loading, results, setResumeList, resumeBanner, page, dataConFig, detailUrl }) => {
    return (
        <ul className="table table-has-more-infomation">
            {results && results.length > 0 ? (
                results?.map((result, index) => {
                    const ITEMS_PER_BANNER = dataConFig?.bannerConfig.grandCnt || 15;
                    const bannersNeeded = Math.floor(results.length / ITEMS_PER_BANNER);
                    const bannerOffset =
                        resumeBanner && resumeBanner.length > 0
                            ? ((page - 1) * bannersNeeded) % resumeBanner.length
                            : 0;
                    const bannerIndex =
                        resumeBanner && resumeBanner.length > 0
                            ? (bannerOffset + Math.floor(index / ITEMS_PER_BANNER)) % resumeBanner.length
                            : 0;
                    return resumeBanner && resumeBanner.length > 0 ? (
                        <React.Fragment key={index}>
                            {index % ITEMS_PER_BANNER === 0 && resumeBanner[bannerIndex] && (
                                <a
                                    href={resumeBanner[bannerIndex].linkUrl}
                                    className="line-after-tab"
                                    target={resumeBanner[bannerIndex].linkType}
                                    onClick={async () => {
                                        await putPAAAA010ClickBanner(resumeBanner[bannerIndex]?.seq);
                                    }}
                                >
                                    <img
                                        src={getImageSrc('banner_photo_resume', resumeBanner[bannerIndex].imgNameMain)}
                                        alt="Dental Job Banner"
                                    />
                                </a>
                            )}
                            <ResumeItem
                                className="resume-list"
                                item={result}
                                key={index}
                                setResumeList={setResumeList}
                                roleAction="C"
                                showStar={true}
                                detailUrl={detailUrl}
                            />
                        </React.Fragment>
                    ) : (
                        <ResumeItem
                            className="resume-list"
                            item={result}
                            key={index}
                            setResumeList={setResumeList}
                            roleAction="C"
                            showStar={true}
                            detailUrl={detailUrl}
                        />
                    );
                })
            ) : (
                <>
                    {loading ? (
                        <p className="center-loadding">
                            <Loader />
                        </p>
                    ) : (
                        <>
                            {resumeBanner && resumeBanner.length > 0 && (
                                <a
                                    href={resumeBanner[0].linkUrl}
                                    className="line-after-tab"
                                    target={resumeBanner[0].linkType}
                                    onClick={async () => {
                                        await putPAAAA010ClickBanner(resumeBanner[0]?.seq);
                                    }}
                                >
                                    <img
                                        src={getImageSrc('banner_photo_resume', resumeBanner[0].imgNameMain)}
                                        alt="Dental Job Banner"
                                    />
                                </a>
                            )}
                            <li className="no-data justify-content-center pb4">등록된 이력서가 없습니다.</li>
                        </>
                    )}
                </>
            )}
        </ul>
    );
};
export default ResumeList;
